import { useContext, useState, createContext, useRef, useMemo } from "react";

import { CSSTransition } from "react-transition-group";

import "./modal.styles.scss";

const TriggersState = createContext();

const Store = (fn) => {
  const ref = useRef();
  let current = ref.current;

  if (!current) current = { v: fn() };

  return current.v;
};

export const ModalWrapper = ({ children }) => {
  const state = useState(false);

  return (
    <TriggersState.Provider value={state}>{children}</TriggersState.Provider>
  );
};

export const ModalTrigger = ({ children, className = "modal-trigger" }) => {
  const { isActive, onClick } = useTriggerState();

  return (
    <div
      className={`${className} ${isActive ? "isActive" : ""}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const useTriggerState = () => {
  const [isActive, setActive] = useContext(TriggersState);
  const onClick = Store(() => () => setActive(!isActive));

  const state = useMemo(
    () => ({
      isActive,
      onClick,
    }),
    [isActive, onClick],
  );

  return state;
};

export const Modal = ({ children }) => {
  const isActive = useModalState();

  return (
    <>
      {isActive && ModalBackdrop()}
      <CSSTransition
        timeout={200}
        in={isActive}
        classNames="modal-panel"
        unmountOnExit
      >
        <div className="modal-panel">
          {ModalClose()}
          {children}
        </div>
      </CSSTransition>
    </>
  );
};

const ModalBackdrop = () => (
  <ModalTrigger>
    <div className="modalBackdrop" />
  </ModalTrigger>
);
const ModalClose = () => (
  <ModalTrigger>
    <div className="modal-close">
      <span className="material-icons">close</span>
    </div>
  </ModalTrigger>
);

const useModalState = () => {
  const [isActive] = useContext(TriggersState);

  return isActive;
};
